import React, { useEffect } from 'react'
import { addWeldersEngineerOne } from '../../../api/welding.api'
import * as actions from '../../../reducers/form';
import SimpleAdd from '../../../components/SimpleAdd'
import { enqueueSnackbar } from '../../../reducers/notifier'
import { useHistory } from 'react-router-dom'
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import validateProps from '../../../functions/validateProps'

const formName = 'WeldersEngineerAdd'
const arrProps = [
  {
    bp: { xs: 12 },
    field: 'lastName', label: 'Фамилия', type: 'text',
    validator: [value => value !== ''], errorText: 'Поле обязательно',
  },
  {
    bp: { xs: 12 },
    field: 'firstName', label: 'Имя', type: 'text',
    validator: [value => value !== ''], errorText: 'Поле обязательно',
  },
  {
    bp: { xs: 12 },
    field: 'middleName', label: 'Отчество', type: 'text',
  },
  {
    bp: { xs: 12 },
    field: 'education', label: 'Специальность и образование', type: 'text',
  },
  {
    bp: { xs: 12 },
    field: 'jobTitle', label: 'Занимаемая должность', type: 'text',
  },
  {
    bp: { xs: 12 },
    field: 'dateStart', label: 'Дата начала работы  на объекте', type: 'text', textProps: { type: 'date' }, labelProps: { shrink: true },
    validator: [value => value !== ''], errorText: 'Поле обязательно',
  },
  {
    bp: { xs: 12 },
    field: 'mark', label: 'Отметка  о прохождении аттестации  и дата', type: 'text',
  },
  {
    bp: { xs: 12 },
    field: 'dateEnd', label: 'Дата  окончания работы  на объекте', type: 'text', textProps: { type: 'date' }, labelProps: { shrink: true },
  },
]
export default function WeldersEngineerAdd(props) {
  const history = useHistory()
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(actions.formInitialize({
      firstName: '',
      lastName: '',
      middleName: '',
      education: '',
      jobTitle: '',
      dateStart: null,
      mark: '',
      dateEnd: null,
      errorValidate: { firstName: false, lastName: false, dateStart: false, mark: false }
    }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch])
  const form = useSelector(state => state.form[formName] || state.form.default)
  const handleSave = (e) => {
    const { values } = form
    e.preventDefault();
    const isError = validateProps(arrProps, values)
    dispatch(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
    if (isError.check) {
      dispatch(enqueueSnackbar({
        message: `некорректные поля`,
        options: { variant: 'error' }
      }))
      return;
    }
    dispatch(actions.formSubmitAPI({
      props: {
        firstName: values.firstName,
        lastName: values.lastName,
        middleName: values.middleName,
        education: values.education,
        jobTitle: values.jobTitle,
        dateStart: values.dateStart,
        mark: values.mark,
        dateEnd: values.dateEnd,
      },
      url: addWeldersEngineerOne.path({ id: props.match.params.idProject }),
      method: addWeldersEngineerOne.type,
      history: history
    }, formName))
  }
  return <div className='App-paper'>
    <form autoComplete="off" onSubmit={handleSave}>
      <div style={{ padding: '16px' }}>
        <SimpleAdd
          formName={formName}
          arr={arrProps}
          title='Добавить персонал'
          gridProps={{ sm: 12, md: 6 }}
        />
      </div>
      <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
      <Button type="submit" color="primary">Сохранить</Button>
    </form>
  </div>
}